<template>
  <div class="container who-are-we">
    <div class="font-size-custom-max-48"><h2 id="font-calc">Onze missie</h2></div>
    <p>Wij willen hoogwaardige digitale oplossingen beschikbaar maken voor <span class="bold">progressieve </span> organisaties waardoor zij mensen kunnen bereiken en meer sociale betrokkenheid kunnen realiseren binnen hun organisatie, om daarmee een bijdrage te leveren aan een meer <span class="bold">zelfbewuste</span>, <span class="bold">duurzame</span> en <span class="bold">inclusieve</span> samenleving.</p>
    <br>
    <p>Kortgezegd moet je bij ons zijn voor een kritische blik naar je huidige merk en het ontwerpen/ontwikkelen van websites/apps, illustraties/animaties en visuele identiteiten.</p>
    <scissorsButton>
     <router-link to="/cultuur" class="button"><p>Ik wil meer lezen over jullie cultuur!</p></router-link>
    </scissorsButton>

  </div>
</template>

<script>

import scissorsButton from '@/components/generalLayout/scissorsButton.vue';
export default {
  name: 'whoWeAre',
  components:{
    scissorsButton
  },    
}
</script>

<style lang="scss" scoped>

.who-are-we{
  padding: layout-val-8(4) layout-val-8(6);
    h2{
      display: table;
      margin: 0 auto;
      position: relative;
      top:0px;
      margin-bottom: layout-val-8(2);
    }

    p{
      text-align: center;
      max-width: 680px;
      margin: 0 auto;
    }

   a{
    text-decoration: none;
    p{
      font-weight: 900;
    }
  }
  .button{
    margin-top: layout-val-8(3);
    margin-bottom: layout-val-8(6);
  }
}
.bold {
  font-weight: 800;
}
</style>